import { env } from './index';

/**
 * Get the Google Tag Manager ID from environment variables
 * @returns GTM ID string
 */
export const getGTMId = (): string => {
  const gtmId = env('NEXT_PUBLIC_GTM_ID');

  if (!gtmId) {
    console.warn('NEXT_PUBLIC_GTM_ID environment variable is not set. Google Tag Manager will not function properly.');
    return '';
  }

  return gtmId;
};
